import {CasinoLegacyDeepLinkActionBase} from '../casino-legacy-deep-link-action-base';

export class FreePlayDeepLinkAction extends CasinoLegacyDeepLinkActionBase {
  async execute(): Promise<void> {


    if(!await this.services.user.ensureUserIsLoggedIn('FreePlayDeepLinkAction')){
      throw new Error('FreePlayDeepLinkAction failed because user is not logged in')
    }

    this.services.freePlay.registerActionToExecuteWhenFreePlayIsAvailable(async () => {
      if(this.services.freePlay.hasVouchers) {
        (await this.services.userMenu).openRewards();
      }
    });

    await this._executeNextAction();
  }
}
